import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ViewChild, ElementRef, AfterViewInit, AfterContentInit, AfterContentChecked } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { ReceiptService } from '../../../../services/receipt.service';
import { TranslateService } from '@ngx-translate/core';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'commercial-details-items',
  templateUrl: './commercial-details-items.component.html',
  styleUrls: ['./commercial-details-items.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1,
        display: 'block'
      })),
      state('closed', style({

        opacity: 0,
        display: 'none'

      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class CommercialDetailsItemsComponent implements OnInit {
  @Input() invoiceItems: any;
  @Input() receiptData;

  BranchWeightUnit: any;
  countries = [];

  defaultItem = {
    desc: '',
    quntity: 0,
    unitType: '',
    unitPrice: 0,
    hrmValue: '',
    ref: '',
    currency: '',
    mfCountry: ''
  }
  shipmentItems: any[] = [];
  isOpen: boolean = true;
  openIndex = -1;

  constructor( private utilities: UtilitiesService, private translate: TranslateService) {
    this.BranchWeightUnit = JSON.parse(sessionStorage.getItem("company")).BranchCompanyDefaultWeightUnit;
  }

  addNewShipmentItem() {
    this.shipmentItems.push({...this.defaultItem});
    this.openIndex = this.shipmentItems.length - 1;
  }

  deleteShipment(i) {
    this.shipmentItems.splice(i, 1);
  }

  editShipment(index) {
    this.openIndex = index;
  }

  getTotal() {
    var totalPrice = 0;
    var totalPieces = 0;
    this.shipmentItems.forEach((item, i) => {
      totalPrice += parseFloat(item.unitPrice);
      totalPieces += parseFloat(item.quntity);
    });
    if (this.shipmentItems.length > 0) {
      return {
        totalPrice: this.fixDecimals(totalPrice),
        totalPieces: this.fixDecimals(totalPieces)
      }
    }
    else {
      return {
        totalPrice: this.fixDecimals(0),
        totalPieces: this.fixDecimals(0)
      }
    }
  }

  fixDecimals(value: any = 0) {
    if (value != 0) {
      value = parseFloat(value).toFixed(2);
      return value;
    }
    else {
      return 0;
    }
  }

  onBlurClick() {
    this.openIndex = -1;
  }

  onDoneClick() {
    this.openIndex = -1;
  }

  ngOnInit() {
    if (this.invoiceItems.length > 0) {
      this.shipmentItems = this.invoiceItems;
    } else {
      let totalQuntity = 0; 
      this.receiptData.shipmentItems.forEach((item) => {
        totalQuntity += item.NoPieces;
      })
      const obj = {
        ...this.defaultItem,
        desc: this.receiptData.commodity.selectedCommodity.key,
        unitType: this.receiptData.commodity.selectedCommodity.key,
        unitPrice: this.receiptData.commodity.goodsValue,
        mfCountry: this.receiptData.country.key,
        currency: this.receiptData.commodity.branchCurrencyCode,
        quntity: totalQuntity,
      }
      this.shipmentItems.push(obj);
    }

    this.utilities.getCountries((res) => {
      this.countries = res;
  }, (err) => { });
  }
}
